module.exports = __webpack_public_path__ + "static/media/保腎護心網layout物件_08.3b243b41.png";